/**
 * Дефолты пережатия фото при загрузке — ЕДИНЫЙ источник для сервера и клиента.
 *
 * Сервер (`ImageProcessingService.compressForUpload`) применяет их, когда в
 * опциях не заданы явные значения; клиент (галочка «Оптимизировать изображения»
 * в FileUploadModal) шлёт их явно — транспорт не передаёт пустые опции — и
 * показывает в подсказке. Правится в одном месте.
 */
export const UPLOAD_IMAGE_DEFAULTS = {
  /** Макс. сторона результата в px (fit inside, без увеличения). */
  width: 1920,
  /** Качество JPEG 1-100. */
  quality: 80,
} as const;

/**
 * Типы, которые безопасно пережимать МОЛЧА (галочка по умолчанию).
 *
 * `image/gif` сознательно не входит: сжатие кодирует в JPEG, и анимированный
 * GIF превратился бы в статичную картинку. Явные `imageProcessingOptions`
 * вызывающего это ограничение не наследуют — там решает вызывающий.
 */
export const SILENT_COMPRESS_IMAGE_TYPES: readonly string[] = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/avif',
];
